import { Notification } from './Notification';
import { NotificationLevel } from './Notification.enums';

export const ErrorHandlerNotitification = (message: string) =>
    function ErrorHandlerComponent() {
        return <Notification level={NotificationLevel.ERROR} message={message} />;
    };
